const getPricingModalContentType = ({ isOutlet }) =>
  isOutlet ? "rrp_pricing_info" : "was_pricing_info";

export default getPricingModalContentType;
